<template>
  <div class="raw">
    <div class="top">
      <img class="line" src="../../assets/index/line.png" alt="" />
      <div class="title">甄选原材</div>
    </div>
    <div class="part">
      <div class="" v-for="(item, index) in datalist" :key="index">
        <div class="part1-2" v-if="index % 2 == 0">
          <div class="up">
            <div class="sort">{{ item.id }}</div>
            <div class="origin">{{ item.title }}</div>
          </div>
          <div class="down">
            <div class="left">
              <div class="tab">
                <div
                  v-for="(a, b) in item.advantage"
                  :key="b"
                  class="tabTitle"
                  style=""
                >
                  {{ a.title }}
                </div>
              </div>
              <div class="list">
                <div class="item" v-for="(a, b) in item.advantage" :key="b">
                  <span class="circle"></span>{{ a.intro }}
                </div>
              </div>
              <!-- <div class="desc">
                {{ item.desc }}
              </div> -->
            </div>
            <div class="right">
              <div class="img">
                <img :src="item.image" alt="" />
              </div>
            </div>
          </div>
          <div class="desc">
            {{ item.desc }}
          </div>
        </div>
        <div class="part1-1" v-else>
          <div class="up">
            <div class="sort">{{ item.id }}</div>
            <div class="origin">{{ item.title }}</div>
          </div>
          <div class="down">
            <div class="left">
              <div class="tab">
                <div
                  v-for="(a, b) in item.advantage"
                  :key="b"
                  class="tabTitle"
                  style=""
                >
                  {{ a.title }}
                </div>
              </div>
              <div class="list">
                <div class="item" v-for="(a, b) in item.advantage" :key="b">
                  {{ a.intro }}<span class="circle"></span>
                </div>
              </div>
              <!-- <div class="desc">
                {{ item.desc }}
              </div> -->
            </div>
            <div class="right">
              <div class="img">
                <img :src="item.image" alt="" />
              </div>
            </div>
          </div>
          <div class="desc">
            {{ item.desc }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { material } from "../../api/request";

export default {
  name: "Raw",
  data() {
    return {
      datalist: [],
    };
  },
  mounted() {
    material().then((res) => {
      if (res.data.code == 1) {
        console.log(res.data.data[0]);
        this.datalist = res.data.data;
      }
    });
  },
};
</script>

<style scoped lang="less">
.raw {
  font-family: 微软雅黑, MicrosoftYaHei;
  .top {
    text-align: left;
    margin-left: 320px;
    background: #ffffff;
    width: 100%;
    padding: 59px 0;
    .line {
    }
    .title {
      font-size: 42px;
      font-family: MicrosoftYaHei;
      font-weight: bold;
      color: #004c31;
      margin-top: 24px;
    }
  }
  .part {
    // 双
    .part1-2 {
      background: #f3f3f3;

      padding: 100px 0;
      padding-left: 15vw;
      padding-right: 15vw;
      // width: 1280px;
      // margin: 0 auto;
      overflow: hidden;
      .up {
        overflow: hidden;
        // float: right;

        display: flex;
        align-items: center;
        justify-content: flex-start;
        .sort {
          // float: right;
          font-size: 42px;
          font-weight: bold;
          color: #004c31;
          border-bottom: 6px solid #ffcc3f;
        }
        .origin {
          // float: right;

          margin-left: 26px;
          font-size: 42px;
          font-weight: bold;
          color: #004c31;
          border-bottom: 6px solid #1f945c;
        }
      }

      .down {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        .left {
          .tab {
            // border: 1px solid blue;
            margin-top: 41px;
            display: flex;
            align-items: center;
            // width: 500px;
            margin-left: -20px;
            // justify-content: space-between;
            .tabTitle {
              border-right: 1px solid #004c31;
              font-size: 32px;
              font-weight: bold;
              color: #004c31;
              padding: 0 20px;
            }
            .tabTitle:last-child {
              border: none;
            }
          }
          .list {
            margin-top: 42px;
            .item {
              display: flex;
              align-items: center;
              font-size: 20px;
              font-weight: 400;
              color: #1f945c;
              margin-top: 8px;
              .circle {
                margin-right: 13px;
                display: block;
                width: 16px;
                height: 16px;
                border-radius: 500px;
                background: #ffd23f;
              }
            }
          }
        }
        .right {
          .img {
            margin-top: 42px;
            width: 560px;
            height: 378px;
            img {
              width: 560px;
              height: 378px;
            }
          }
          .logo {
            text-align: right;
            margin-top: 100px;
            font-size: 10px;
            font-family: MicrosoftYaHei;
            font-weight: bold;
            color: #dcdcdc;
            line-height: 20px;
          }
        }
      }

      .desc {
        line-height: 36px;
        margin-top: 44px;
        width: 640px;
        font-size: 20px;
        color: #6c7a77;
        text-align: justify;
      }
    }

    // 单
    .part1-1 {
      background: #fff;
      padding: 100px 0;
      width: 1280px;
      margin: 0 auto;
      overflow: hidden;
      .up {
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        // float: left;
        .sort {
          // float: left;
          font-size: 42px;
          font-weight: bold;
          color: #004c31;
          border-bottom: 6px solid #ffcc3f;
        }
        .origin {
          // float: left;
          margin-left: 26px;
          font-size: 42px;
          font-weight: bold;
          color: #004c31;
          border-bottom: 6px solid #1f945c;
        }
      }

      .down {
        // display: flex;
        // align-items: flex-start;
        // justify-content: space-between;
        overflow: hidden;

        .left {
          float: right;
          .tab {
            display: flex;
            justify-content: flex-end;
            margin-top: 41px;
            display: flex;
            align-items: center;
            // width: 500px;
            // justify-content: space-between;
            .tabTitle {
              border-right: 1px solid #004c31;
              font-size: 32px;
              font-weight: bold;
              color: #004c31;
              padding: 0 20px;
            }
            .tabTitle:last-child {
              border: none;
              padding-right: 0;
            }
          }
          .list {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            text-align: right;
            // border: 1px solid orange;

            margin-top: 42px;
            .item {
              display: flex;
              align-items: center;
              font-size: 20px;
              font-weight: 400;
              color: #1f945c;
              margin-top: 8px;
              .circle {
                // border: 1px solid blue;
                margin-left: 13px;
                display: block;
                width: 16px;
                height: 16px;
                border-radius: 500px;
                background: #ffd23f;
              }
            }
          }
        }
        .right {
          float: left;

          .img {
            margin-top: 42px;
            width: 560px;
            height: 378px;
            img {
              width: 560px;
              height: 378px;
            }
          }
          .logo {
            text-align: right;
            margin-top: 100px;
            font-size: 10px;
            font-family: MicrosoftYaHei;
            font-weight: bold;
            color: #dcdcdc;
            line-height: 20px;
          }
        }
      }
      .desc {
        line-height: 36px;
        margin-top: 44px;
        width: 640px;
        font-size: 20px;
        color: #6c7a77;
        text-align: justify;
      }
    }
  }

  // .part:nth-child(even) {
  //   background: #fff;
  // }
  // .part:nth-child(odd) {
  //   background: #f3f3f3;
  // }
}

@media screen and (max-width: 450px) {
  .raw {
    font-family: 微软雅黑, MicrosoftYaHei;
    .top {
      text-align: left;
      margin-left: 320px;
      background: #ffffff;
      width: auto;
      padding: 59px 0;
      .line {
        width: 90 * 2px;
        height: 8 * 2px;
      }
      .title {
        font-size: 42 * 2px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
        color: #004c31;
        margin-top: 24 * 2px;
      }
    }
  }

  // 移动
  .part {
    // 双
    .part1-2 {
      // border: 1px solid blue;
      background: #f3f3f3;

      padding: 50px 50px 50px 50px !important;
      overflow: hidden;
      .up {
        // overflow: hidden;
        // display: flex;
        // align-items: center;
        // justify-content: flex-start;
        .sort {
          // float: right;
          font-size: 42 * 2px !important;
          font-weight: bold;
          color: #004c31;
          border-bottom: 6px solid #ffcc3f;
        }
        .origin {
          // float: right;
          margin-left: 26 * 2px !important;
          font-size: 42 * 2px !important;
          font-weight: bold;
          color: #004c31;
          border-bottom: 6px solid #1f945c;
        }
      }

      .down {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        .left {
          .tab {
            margin-top: 41 * 2px !important;
            display: flex;
            align-items: center;
            margin-left: -20 * 2px !important;
            .tabTitle {
              border-right: 1px solid #004c31;
              font-size: 32 * 2px !important;
              font-weight: bold;
              color: #004c31;
              padding: 0 20 * 2px !important;
            }
            .tabTitle:last-child {
              border: none;
            }
          }
          .list {
            margin-top: 42 * 2px !important;
            .item {
              display: flex;
              align-items: center;
              font-size: 20px;
              font-weight: 400;
              color: #1f945c;
              margin-top: 8px;
              .circle {
                margin-right: 13 * 2px !important;
                display: block;
                width: 16 * 2px !important;
                height: 16 * 2px !important;
                border-radius: 500px;
                background: #ffd23f;
              }
            }
          }
        }
        .right {
          .img {
            margin-top: 42 * 2px !important;
            width: 560px;
            height: 378px;
            img {
              width: 560px;
              height: 378px;
            }
          }
          .logo {
            text-align: right;
            margin-top: 100 * 2px;
            font-size: 10px;
            font-family: MicrosoftYaHei;
            font-weight: bold;
            color: #dcdcdc;
            line-height: 20px;
          }
        }
      }
      .desc {
        line-height: 36 * 2px !important;
        margin-top: 44 * 2px !important;
        width: 100% !important;
        font-size: 20px !important;
        color: #6c7a77;
        text-align: justify;
      }
    }

    // 单
    .part1-1 {
      width: 96vw !important;
      // border: 1px solid blue;
      background: #fff;
      padding: 50px 50px 50px 50px !important;
      overflow: hidden;
      .up {
        // margin-right: 100px !important;
        // display: flex;
        // align-items: center;
        // justify-content: flex-end;
        // float: left;
        .sort {
          // float: left;
          font-size: 42 * 2px !important;
          font-weight: bold;
          color: #004c31;
          border-bottom: 6px solid #ffcc3f;
        }
        .origin {
          // float: left;
          margin-left: 26 * 2px !important;
          font-size: 42 * 2px !important;
          font-weight: bold;
          color: #004c31;
          border-bottom: 6px solid #1f945c;
        }
      }

      .down {
        // border: 1px solid #000;
        // margin-right: 100px !important;

        // align-items: flex-start;
        // justify-content: space-between;
        overflow: hidden;

        .left {
          float: right;

          .tab {
            display: flex;
            justify-content: flex-end;
            margin-top: 41 * 2px !important;
            display: flex;
            align-items: center;
            margin-right: -20 * 2px !important;

            // width: 500px;
            // justify-content: space-between;
            .tabTitle {
              border-right: 1px solid #004c31;
              font-size: 32 * 2px;
              font-weight: bold;
              color: #004c31;
              padding: 0 20 * 2px !important;
            }
            .tabTitle:last-child {
              border: none;
              // padding-right: 0;
            }
          }
          .list {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            text-align: right;
            // border: 1px solid orange;

            margin-top: 42 * 2px !important;
            .item {
              display: flex;
              align-items: center;
              font-size: 16px !important;
              font-weight: 400;
              color: #1f945c;
              margin-top: 8px;
              .circle {
                // border: 1px solid blue;
                margin-left: 13px;
                display: block;
                width: 16px !important;
                height: 16px !important;
                border-radius: 500px;
                background: #ffd23f;
              }
            }
          }
        }
        .right {
          float: left;

          .img {
            margin-top: 42px;
            width: 550px !important;
            height: 360px !important;
            img {
              width: 550px !important;
              height: 360px !important;
            }
          }
          .logo {
            text-align: right;
            margin-top: 100px;
            font-size: 10px;
            font-family: MicrosoftYaHei;
            font-weight: bold;
            color: #dcdcdc;
            line-height: 20px;
          }
        }
      }
      .desc {
        line-height: 36 * 2px !important;
        margin-top: 44 * 2px !important;
        width: 96vw !important;
        font-size: 20px !important;
        color: #6c7a77;
        // text-align: left;
        // padding-right: 100px !important;
      }
    }
  }
}
</style>
